import { trackPromise } from 'react-promise-tracker';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { getNotificationStyle } from "../common/notification";
import { calculateVATAmount } from '../components/BookingComponent/Booking/common';
import { AccountInterface, IAccountDetail, IBooking, IBookingCreationResponse, IBookingInitial, IBookingState, IBulkPrint, ICashCustomerAccount, IConsigneeRequest, ICountryCityWithOutAgreement, ICreateSubWaybillsRequest, IFetchFiles, IFile, IGoogleRequest, IOriginDestination, IOriginDestinationRequest, IPickupException, IProofOfDeliveryRequest, IRejectException, IReschedule, IShipperAndAccountDetailRequest, IShipperRequest, ISubProductList, ISubWaybillPrint, IUpdateBookingStatus, IValidAgreementDetailRequest } from '../model/BookingModel';
import { IFilter, IPODPendingSearchFilter } from '../model/CommonModel';
import { ICity, ICountryInterface } from '../model/MasterModel';
import { IDWSChangeDeliveryDate, IUpdatePickUpDetails } from '../model/OperationModel';
import {
    BookingRescheduleService,
    CancelBookingByIdService,
    CancelRtoWaybillService,
    CreateSubWaybillsService,
    DWSBookingRescheduleService,
    DeleteFileByIdService,
    DeleteProofOfDeliveryService,
    DispatchWorkStationService,
    DownloadBookingExcelService,
    GetAccountDetailByIdService,
    GetAccountNameByIdService,
    GetAllBusinessGroupsService,
    GetAllProductsService,
    GetAllSubProductService,
    GetAllTemperatureService,
    GetBookingDetailByIdService,
    GetBookingListService,
    GetCommodityListService,
    GetConsigneeDetailService,
    GetConsigneeDetailsByIdService,
    GetConsigneeDetailsByShipperAndAccountDetailsService,
    GetCountryWithOutAgreementService,
    GetCustomerAddressByIdService,
    GetCustomerByFilterService,
    GetCustomerByIdService,
    GetCustomerBySalesManIdService,
    GetCustomerBySalesPersonService,
    GetFtlConsigneeDetailsByIdService,
    GetFtlShipperDetailsByIdService,
    GetOriginDestinationCountryCityService,
    GetProductSubProductTemperatureDetailsService,
    GetProductsService,
    GetProofOfDeliveryService,
    GetReporteesService,
    GetRescheduleDetailService,
    GetShipperDetailService,
    GetShipperDetailsByAccountDetailsService,
    GetShipperDetailsByIdService,
    GetSubWaybillsService,
    GetUploadedFileListService,
    GetValidAgreementDetailService,
    PickupExceptionService,
    PrintBulkStickerService,
    PrintBulkWayBillService,
    PrintSubWaybillService,
    PrintSubWaybillStickerService,
    ProductDescriptionByProductIdService,
    RejectExceptionService,
    SaveBookingService,
    SaveConsigneeService,
    SaveProofOfDeliveryService,
    SaveShipperService,
    SaveShipperSubCityService,
    SaveSubCityConsigneeService,
    TrackVehicleByPlateNumberService,
    UpdateBookingConsigneeDetailsAction,
    UpdateBookingDetailService,
    UpdateBookingPickUpDetailsService,
    UpdateBookingShipperDetailsAction,
    UpdateBookingStatusService,
    UpdateConsigneeByIdV2Service,
    UpdateShipperByIdV2Service,
    UploadBulkBooingService,
    UploadFileService
} from '../services/booking-service';
import { GetPodConsigneesService, GetPodPendingService, GetPodShippersService, SearchFilterService, SearchPodPendingFilterService } from '../services/common-service';
import { FOUR_HUNDRED, TWO_HUNDRED_SUCCESS_CODE, downloadURL, isAoneUrl, isRtoWaybill, removeDuplicateObjects } from '../utils/app-common';
import { ITemperatureList } from './../model/BookingModel';
import { IFileUpload } from './../model/CommonModel';
import { GetCustomerAccountService, SaveCashCustomerService, TrackWayBillService, UpdateConsigneeGoogleAddressService, UpdateShipperGoogleAddressService } from './../services/booking-service';
import { downloadBlob, fileFormat } from './../utils/app-common';
import { convertDateIntoMillis, convertMillisToDateMoment, monthsDate, ONE_MONTH, todayDate } from './../utils/luxon';
import { BookingUploadFormData, messageEnum, responseData } from "./common";
import { GetOperationFilesListService } from '../services/operation-service';

const initialValue: IBookingInitial = {
    bookingList: [],
    accountList: [],
    salesPersonAccountList: [],
    subProductList: [],
    productList: [],
    temperatureList: [],
    shippersList: [],
    accountName: {},
    bookingDetail: {},
    bookingSuccess: undefined,
    accountDetailList: [],
    proofOfDeliveryList: [],
    airWayBillTracking: {},
    cashCustomerResponse: undefined,
    shipperResponse: undefined,
    consigneeResponse: undefined,
    customerShipperAddress: {},
    originDestination: {},
    uploadBulkFileResponse: undefined,
    printResponse: undefined,
    bookingRescheduleResponse: undefined,
    updatePickUpResponse: undefined,
    deleteFileResponse: undefined,
    updateShipperResponse: undefined,
    updateConsigneeResponse: undefined,
    podResponse: undefined,
    consigneeCountryCity: {},
    shipperCountryCity: {},
    consigneeList: [],
    podDispatchPendingList: [],
    podShipperList: [],
    podConsigneeList: [],
    productDescription: {},
    accountDetail: {},
    uploadedFiles: [],
    salesmanCustomerList: [],
    accountFilteredList: [],
    dispatchWorkStations: [],
    agreementDetail: {},
    shipperDetail: {},
    consigneeDetail: {},
    businessGroupList: [],
    reporteeList: [],
    subWaybillList: [],
    commodityList: [],
}

const BookingStore = create<IBookingState>()(devtools((set, get) => ({
    ...initialValue,

    GetBookingListAction: async (filteredData: Partial<IFilter>) => {
        set({ bookingList: [] });
        const payload: Partial<IFilter> = {
            ...filteredData,
            startDate: filteredData?.startDate ? filteredData?.startDate : convertDateIntoMillis(monthsDate(todayDate(), ONE_MONTH)),
            endDate: filteredData?.endDate ? filteredData?.endDate : convertDateIntoMillis(todayDate()),
        }
        const response = await GetBookingListService(payload);
        set({ bookingList: responseData(response?.data) })
    },
    GetCustomerByIdAction: async (id?: number, isFinance: boolean = false) => {
        const response = await GetCustomerByIdService(isFinance, id);
        set({ accountList: removeDuplicateObjects(responseData(response?.data), 'accountId') as AccountInterface[] })
    },
    GetCustomerBySalesPersonAction: async () => {
        const response = await GetCustomerBySalesPersonService();
        set({ salesPersonAccountList: removeDuplicateObjects(responseData(response?.data), 'accountId') as AccountInterface[] })
    },
    GetAllSubProductAction: async () => {
        const response = await GetAllSubProductService();
        set({ subProductList: responseData(response?.data) })
    },
    // GetTemperatureByIdAction: async (productId: number, subProductId: number, subClientId: number) => {
    //     const response = await GetTemperatureByIdService(productId, subProductId, subClientId);
    //     set({ temperatureList: responseData(response?.data) })
    // },
    GetAllTemperatureAction: async () => {
        const response = await GetAllTemperatureService();
        set({ temperatureList: responseData(response?.data) })
    },
    GetSubProductByIdAction: (list: ISubProductList[]) => {
        set({ subProductList: list });
    },
    GetProductAction: async (subId: number) => {
        const response = await GetProductsService(subId);
        set({ productList: responseData(response?.data) })
    },
    GetAllProductsAction: async () => {
        const response = await GetAllProductsService();
        set({ productList: responseData(response?.data) })
    },
    GetTemperatureByIdAction: (list: ITemperatureList[]) => {
        set({ temperatureList: list })
    },
    GetShipperDetailsByIdAction: async (id: number) => {
        const response = await GetShipperDetailsByIdService(id);
        set({
            shipperCountryCity: { shipperDtoList: responseData(response?.data) },
            shippersList: responseData(response?.data)
        })
    },
    GetFtlShipperDetailsByIdAction: async (id: number, isFtl = false) => {
        const response = await GetFtlShipperDetailsByIdService(id, isFtl);
        set({
            shipperCountryCity: { shipperDtoList: responseData(response?.data) },
            shippersList: responseData(response?.data)
        })
    },
    GetConsigneeDetailsByIdAction: async (id: number) => {
        const response = await GetConsigneeDetailsByIdService(id);
        set({ consigneeCountryCity: { consigneeDtoList: responseData(response?.data) }, consigneeList: responseData(response?.data) })
    },
    GetFtlConsigneeDetailsByIdAction: async (id: number, isFtl = false) => {
        const response = await GetFtlConsigneeDetailsByIdService(id, isFtl);
        set({ consigneeCountryCity: { consigneeDtoList: responseData(response?.data) }, consigneeList: responseData(response?.data) })
    },
    GetConsigneeDetailsByShipperAndAccountDetailsAction: async (request: IShipperAndAccountDetailRequest, countryId?: number) => {
        const response = await GetConsigneeDetailsByShipperAndAccountDetailsService(request);
        const data = responseData(response?.data);
        const merged = {
            ...data,
            country: data.dest.country,
            city: data.dest.city,
            filteredCity: removeDuplicateObjects([...data.dest.city].filter((i: ICity) => i?.countryId === countryId), 'id') as ICity[]
        };
        set({ consigneeCountryCity: merged })
    },
    GetShipperDetailsByAccountDetailsAction: async (request: Omit<IShipperAndAccountDetailRequest, 'originCityId'>) => {
        const response = await GetShipperDetailsByAccountDetailsService(request);
        const data = responseData(response?.data);
        const merged = {
            ...data,
            country: data.origin.country,
            city: data.origin.city
        };
        set({ shipperCountryCity: merged })
    },
    SaveBookingAction: async (data: IBooking) => {
        const response = await SaveBookingService(data);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            const data: IBookingCreationResponse = responseData(response?.data);
            const uploadFileList = get().uploadedFiles ?? [];
            if (uploadFileList.length) {
                const request: IFile = {
                    wayBillNumber: data?.waybillNo,
                    category: 'booking',
                    fileType: 'Create Booking File',
                    files: uploadFileList
                }
                const { formData, configuration } = BookingUploadFormData(request);
                trackPromise(get().UploadFileAction({ formData, configuration }), 'upload-file-area');
            }
            set({ bookingSuccess: statusCode, productDescription: {} });
            getNotificationStyle({ ...response, statusText: messageEnum.BOOKING_CREATED_SUCCESSFULLY });
            get().GetPodPendingAction();
        }
    },
    UpdateShipperGoogleAddressAction: async (data: IGoogleRequest) => {
        const response = await UpdateShipperGoogleAddressService(data);
        getNotificationStyle(response);
    },
    UpdateConsigneeGoogleAddressAction: async (data: IGoogleRequest) => {
        const response = await UpdateConsigneeGoogleAddressService(data);
        getNotificationStyle(response);
    },
    SaveShipperAction: async (data: IShipperRequest) => {
        const response = await SaveShipperService(data);
        const list = get().shipperCountryCity?.shipperDtoList ?? [];
        const { statusCode, ...rest } = (response?.data) || {};
        set({
            shipperResponse: statusCode,
            shipperCountryCity: { shipperDtoList: [...list, rest.data] },
        });
        get().GetPodShippersAction();
        getNotificationStyle(response);
    },
    GetPodShippersAction: async () => {
        const response = await GetPodShippersService();
        const convertedResponse = responseData(response?.data);
        set({ podShipperList: convertedResponse })
    },
    SaveSubCityShipperAction: async (data: IShipperRequest, customerSubAccountId: number) => {
        const response = await SaveShipperSubCityService(data);
        //const list = get().shippersList || [];
        // set({ shippersList: [...list, responseData(response?.data)] });
        get().GetShipperDetailsByIdAction(customerSubAccountId);
        if (responseData(response?.data).length) {
            const list = get().shipperCountryCity?.shipperDtoList ?? [];
            set({ shipperCountryCity: { shipperDtoList: [...list, responseData(response?.data)] } })
        }
        getNotificationStyle(response);
    },
    SaveSubCityConsigneeAction: async (data: IShipperRequest, customerSubAccountId: number) => {
        const response = await SaveSubCityConsigneeService(data);
        // const list = get().shippersList;
        // set({ shippersList: [...list, responseData(response?.data)] })
        get().GetConsigneeDetailsByIdAction(customerSubAccountId);
        if (responseData(response?.data).length) {
            const list = get().consigneeCountryCity?.consigneeDtoList ?? [];
            set({ consigneeCountryCity: { consigneeDtoList: [...list, responseData(response?.data)] } })
        }
        getNotificationStyle(response);
    },
    SaveConsigneeAction: async (data: IConsigneeRequest) => {
        const response = await SaveConsigneeService(data);
        const list = get().consigneeCountryCity?.consigneeDtoList ?? [];
        const { statusCode, ...rest } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle(response);
            set({
                consigneeCountryCity: { consigneeDtoList: [...list, rest.data] },
                consigneeResponse: statusCode,
            });
            get().GetPodConsigneesAction();
        }
        return response;
    },
    GetPodConsigneesAction: async () => {
        const response = await GetPodConsigneesService();
        const convertedResponse = responseData(response?.data);
        set({ podConsigneeList: convertedResponse })
    },
    GetBookingDetailByIdAction: async (id?: number) => {
        set({ bookingDetail: {} });
        const response = await GetBookingDetailByIdService(id);
        const data = responseData(response?.data);
        const proofOfDeliveryList = get().proofOfDeliveryList;
        const { freightCharge, additionalCharges, vatPercentage, insurance, totalAmount } = data?.cashCustomerDetails || {};
        const modifiedResponse = {
            ...data,
            pickupDatetimeMs: convertMillisToDateMoment(data?.pickupDatetimeMs),
            etdDeliverytimeMs: data?.etdDeliverytimeMs && convertMillisToDateMoment(data?.etdDeliverytimeMs),
            cashId: data?.cashCustomerDetails?.id,
            additionalCharges,
            freightCharge,
            vatPercentage,
            insurance,
            totalAmount,
            vatAmount: calculateVATAmount({
                freightCharge,
                additionalCharges,
                vatPercentage
            }),
            podList:
                data?.podList?.map((pod: any) => ({
                    ...pod,
                    isDisabled: true,
                    isTextNeeded: proofOfDeliveryList?.find(
                        (item) => item?.id === pod?.podFileOptionsId
                    )?.isTextNeeded,
                })) ?? [],
            isCod: data?.codAmount && (data?.codAmount > 0) ? true : false,
        };
        set({ bookingDetail: { ...modifiedResponse } });
    },
    UpdateBookingDetailAction: async (id: number | undefined, data: IBooking) => {
        const response = await UpdateBookingDetailService(id, data);
        getNotificationStyle(response);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            const data: IBookingCreationResponse = responseData(response?.data);
            const uploadFileList: any[] = get().uploadedFiles?.filter(item => !item?.id) ?? [];
            if (uploadFileList.length) {
                const request: IFile = {
                    wayBillNumber: data?.waybillNo,
                    category: 'booking',
                    fileType: 'Create Booking File',
                    files: uploadFileList
                }
                const { formData, configuration } = BookingUploadFormData(request);
                trackPromise(get().UploadFileAction({ formData, configuration }), 'upload-file-area');
            }
            set({ bookingSuccess: statusCode })
        }
    },
    CancelBookingByIdAction: async (id: number | undefined, filteredData: Partial<IFilter>, request?: { cancelReasonId: null, cancelRemarks?: undefined },
        calledFrom?: {
            booking?: boolean,
            dispatch?: boolean
        }, waybillNo?: string) => {
        if (waybillNo && isRtoWaybill(waybillNo)) {
            const response = await CancelRtoWaybillService(waybillNo);
            // HTTP errors are already notified by the service
            if (!response || response.status !== TWO_HUNDRED_SUCCESS_CODE) return false;
            if (response.data?.statusCode !== TWO_HUNDRED_SUCCESS_CODE) {
                getNotificationStyle(response.data);
                return false;
            }
            getNotificationStyle(response);
            return true;
        }
        const response = await CancelBookingByIdService(id, request);
        getNotificationStyle(response);
        return response?.status === TWO_HUNDRED_SUCCESS_CODE;
    },
    GetAccountNameById: async (id: number) => {
        const response = await GetAccountNameByIdService(id);
        set({ accountName: responseData(response?.data) })
    },
    GetAccountDetailByIdAction: async (id: number) => {
        set({ accountDetail: {} });
        const response = await GetAccountDetailByIdService(id);
        const data = responseData(response?.data);
        const modifiedResponse: IAccountDetail = {
            ...data,
            address: `${data?.customerAddressList?.at(0)?.addressStreet ?? ''} - ${data?.customerAddressList?.at(0)?.postalCode ?? ''} `,
            countryId: data?.customerAddressList?.at(0)?.countryId,
            cityId: data?.customerAddressList?.at(0)?.cityId,
            contactPerson: data?.salesPersonName ?? data?.bothSalesPersonName ?? data?.irsSalesPersonName,
            mobile: data?.customerAddressList?.at(0)?.mobile,
            email: data?.customerAddressList?.at(0)?.email,
        };
        set({ accountDetail: modifiedResponse })
    },
    SearchFilterAction: async (filteredData: IFilter) => {
        const response = await SearchFilterService(filteredData);
        set({ bookingList: responseData(response?.data) })
    },
    GetProductSubProductTemperatureDetailsAction: async (id: number) => {
        if (Number.isNaN(id)) return;
        const response = await GetProductSubProductTemperatureDetailsService(id);
        set({ accountDetailList: responseData(response?.data) })
    },
    GetProofOfDeliveryAction: async () => {
        const response = await GetProofOfDeliveryService();
        set({ proofOfDeliveryList: responseData(response?.data) })
    },
    SaveProofOfDeliveryAction: async (data: IProofOfDeliveryRequest, id: number, isPodBooking: boolean = false) => {
        const response = await SaveProofOfDeliveryService(data);
        getNotificationStyle(response);
        const { statusCode } = response?.data || {};
        if (!isPodBooking) {
            get().GetBookingDetailByIdAction(id)
        }
        set({ podResponse: statusCode })

    },
    DeleteProofOfDeliveryAction: async (id: number | undefined, bookingId: number) => {
        const response = await DeleteProofOfDeliveryService(id);
        getNotificationStyle(response);
        get().GetBookingDetailByIdAction(bookingId)
    },
    TrackWayBillAction: async (waybillNumber: string) => {
        const response = await TrackWayBillService(waybillNumber);
        set({ airWayBillTracking: responseData(response?.data) });
        if (response?.status === FOUR_HUNDRED) {
            getNotificationStyle(response);
        }
    },
    TrackVehicleByPlateNumberAction: async (waybillNumber: string) => {
        const response = await TrackVehicleByPlateNumberService(waybillNumber);
        set({ airWayBillTracking: responseData(response?.data) });
        if (response?.status === FOUR_HUNDRED) {
            getNotificationStyle(response);
        }
    },
    GetCustomerAccountDetailAction: async () => {
        const response = await GetCustomerAccountService();
        set({ accountList: removeDuplicateObjects(responseData(response?.data), 'accountId') as AccountInterface[] })
    },
    SaveCashCustomerAction: async (data: ICashCustomerAccount) => {
        const response = await SaveCashCustomerService(data);
        const list = get().accountList;
        const { name, customerCode, clientSubId, clientId } = responseData(response?.data) || {};
        const modifyResponse: AccountInterface = {
            accountId: customerCode,
            accountName: name,
            clientId: clientId,
            subClientId: clientSubId,
        }
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            set({ accountList: [...list, modifyResponse], cashCustomerResponse: statusCode });
            getNotificationStyle(response);
        }
    },
    GetCustomerAddressByIdAction: async (id: number) => {
        const response = await GetCustomerAddressByIdService(id);
        const { countryId, mobile, phone, cityId, addressStreet, client, subClient } = responseData(response?.data)
        const alteredResponse = {
            name: client || subClient,
            address: addressStreet,
            cityId: cityId,
            countryId,
            customerSubAccountId: undefined,
            mobileNumber1: mobile,
            mobileNumber2: phone,
            latitude: 0,
            longitude: 0,
            shipperGoogleAddress: ""
        }
        set({ customerShipperAddress: alteredResponse })
    },
    GetOriginDestinationCountryCityAction: async (request: IOriginDestinationRequest, countryId?: number) => {
        const response = await GetOriginDestinationCountryCityService(request);
        const data = responseData(response?.data);
        const merged: IOriginDestination = {
            ...data,
            country: removeDuplicateObjects([...data.dest.country, ...data.origin.country], 'id') as ICountryInterface[],
            city: removeDuplicateObjects([...data.dest.city, ...data.origin.city], 'id') as ICity[],
            filteredCity: removeDuplicateObjects([...data.dest.city, ...data.origin.city].filter((i: ICity) => i?.countryId === countryId), 'id') as ICity[]
        };
        set({ originDestination: merged })
    },
    UploadBulkBookingAction: async (file: Partial<IFileUpload>, filteredData: IFilter) => {
        const response = await UploadBulkBooingService(file);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            set({ uploadBulkFileResponse: statusCode })
            // trackPromise(get().GetBookingListAction(filteredData), 'booking-list-area');
        }
    },
    DownloadBookingExcelAction: async () => {
        const response = await DownloadBookingExcelService();
        const { fileName, fileType, file } = responseData(response?.data);
        downloadBlob(file, fileName, fileFormat[fileType]);
    },
    GetCountryWithOutAgreementAction: async (request: ICountryCityWithOutAgreement) => {
        const response = await GetCountryWithOutAgreementService(request);
        const data = responseData(response?.data);
        const merged: IOriginDestination = {
            ...data,
            country: removeDuplicateObjects([...data.dest.country, ...data.origin.country], 'id') as ICountryInterface[],
            city: removeDuplicateObjects([...data.dest.city, ...data.origin.city], 'id') as ICity[],
        };
        set({ originDestination: merged })
    },
    UpdateBookingStatusAction: async (rowId: number | undefined, request: IUpdateBookingStatus, filteredData: Partial<IFilter>) => {
        const response = await UpdateBookingStatusService(rowId, request);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle(response);
        }
        // trackPromise(get().GetBookingListAction(filteredData), 'booking-list-area');
    },
    BookingRescheduleAction: async (request: IReschedule) => {
        const response = await BookingRescheduleService(request);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle(response);
            set({ bookingRescheduleResponse: statusCode })
        }
    },
    // GetBillTypeAction: async () => {
    //     const response = await GetCustomerByIdService(id);
    //     set({ accountList: removeDuplicateObjects(responseData(response?.data), 'accountId') as AccountInterface[] })
    // },
    PrintBulkWayBillAction: async (waybills: IBulkPrint) => {
        const response = await PrintBulkWayBillService(waybills);
        const { statusCode, data } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            trackPromise(downloadURL(data?.response), 'print-bulk-waybill-area');
            set({ printResponse: statusCode })
        }
    },
    ProductDescriptionByProductIdAction: async (request: number) => {
        const response = await ProductDescriptionByProductIdService(request);
        const { data } = response?.data || {};
        set({ productDescription: data })
    },
    PrintBulkStickerAction: async (waybills: IBulkPrint) => {
        const response = await PrintBulkStickerService(waybills);
        const { statusCode, data } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            trackPromise(downloadURL(data?.response), 'print-bulk-sticker-area');
            set({ printResponse: statusCode })
        }
    },
    GetPodPendingAction: async () => {
        const response = await GetPodPendingService();
        const convertedResponse = responseData(response?.data);
        set({ podDispatchPendingList: convertedResponse })
    },
    SearchPodPendingFilterAction: async (filteredData: IPODPendingSearchFilter) => {
        const payload = isAoneUrl() ? { ...filteredData, isAone: true } : filteredData;
        const response = await SearchPodPendingFilterService(payload);
        set({ podDispatchPendingList: responseData(response?.data) });
    },
    UploadFileState: (files: [] = []) => {
        const list = get().uploadedFiles ?? [];
        set({ uploadedFiles: [...files] });
    },
    DeleteUploadFileState: (files: any = {}) => {
        const list: any[] = get().uploadedFiles ?? [];
        const filtered = list?.filter(item => item?.uid !== files?.uid);
        set({ uploadedFiles: filtered });
    },
    UploadFileAction: async (request: { formData: FormData, configuration: {} }) => {
        const response = await UploadFileService(request);
        const { statusCode } = response?.data ?? {};
        if (statusCode !== TWO_HUNDRED_SUCCESS_CODE) getNotificationStyle(response)
        set({ uploadedFiles: [] })
    },
    GetUploadFileAction: async (request: IFetchFiles) => {
        if (!request?.waybillNo) return;
        const response = await trackPromise(GetOperationFilesListService(request?.waybillNo), 'get-waybill-files');
        const { statusCode } = response?.data || {};
        if (statusCode !== TWO_HUNDRED_SUCCESS_CODE) return getNotificationStyle(response);
        const files = responseData(response?.data);
        const fileTypes = ['bookingFileList', 'pickupList', 'deliveryList', 'createBookingFileList'];
        const selectedFiles = fileTypes.flatMap(type =>
            files?.[type]?.map(item => ({ ...item, fileType: type.replace('List', '') })) ?? []
        );
        set({ uploadedFiles: selectedFiles });
    },
    DeleteFileByIdAction: async (id: number, request: IFetchFiles) => {
        const response = await DeleteFileByIdService(id);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle(response);
            get().GetUploadFileAction(request);
        }
    },
    UpdateFileAction: async (request: { formData: FormData, configuration: {} }, fetchRequest: IFetchFiles) => {
        const response = await UploadFileService(request);
        const { statusCode } = response?.data || {};
        if (statusCode) {
            getNotificationStyle(response);
            get().GetUploadFileAction(fetchRequest);
            set({ uploadedFiles: [] })
        }
    },
    UpdateBookingPickUpDetailsAction: async (request: IUpdatePickUpDetails, id?: number) => {
        const response = await UpdateBookingPickUpDetailsService(request);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            set({ updatePickUpResponse: response?.status })
            getNotificationStyle(response);
            if (id) trackPromise(get().GetBookingDetailByIdAction(+(id)), 'bookingDetails-list-area');
        }
    },
    UpdateBookingShipperDetailsAction: async (request: IUpdatePickUpDetails, clientId?: number, id?: number) => {
        const response = await UpdateBookingShipperDetailsAction(request, clientId);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            set({ updateShipperResponse: response?.status })
            getNotificationStyle(response);
            trackPromise(get().GetBookingDetailByIdAction((id)), 'bookingDetails-list-area');
        }
    },
    UpdateBookingConsigneeDetailsAction: async (request: IUpdatePickUpDetails, clientId?: number, id?: number) => {
        const response = await UpdateBookingConsigneeDetailsAction(request, clientId);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            set({ updateConsigneeResponse: response?.status })
            getNotificationStyle(response);
            trackPromise(get().GetBookingDetailByIdAction((id)), 'bookingDetails-list-area');
        }
    },
    GetCustomerBySalesManIdAction: async (id?: number) => {
        const response = await GetCustomerBySalesManIdService(id);
        set({ salesmanCustomerList: removeDuplicateObjects(responseData(response?.data), 'accountId') as AccountInterface[] })
    },
    GetCustomerByFilterAction: async (filter?: string | undefined, isFiltered?: boolean | undefined) => {
        const response = await GetCustomerByFilterService(filter, isFiltered)
        set({ accountFilteredList: removeDuplicateObjects(responseData(response?.data), 'accountId') as AccountInterface[] })
    },
    PickupExceptionAction: async (request: IPickupException, filterData: Partial<IFilter>) => {
        const response = await PickupExceptionService(request);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle(response);
        }
    },
    RejectExceptionAction: async (request: IRejectException, filterData: Partial<IFilter>) => {
        const response = await RejectExceptionService(request);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle(response);
        }
    },
    DispatchWorkStationAction: async (request: Partial<IFilter>) => {
        set({ dispatchWorkStations: [] });
        const response = await DispatchWorkStationService(request);
        set({ dispatchWorkStations: responseData(response?.data) })
    },
    GetValidAgreementDetailAction: async (request: IValidAgreementDetailRequest) => {
        const response = await GetValidAgreementDetailService(request);
        const commodity = await GetCommodityListService(request);

        set({ agreementDetail: responseData(response?.data) || {}, commodityList: responseData(commodity?.data) || [] });
    },
    GetRescheduleDetailAction: async (bookingID: number) => {
        const response = await trackPromise(GetRescheduleDetailService(bookingID), 'reschedule-detail-area');;
        return response;
    },
    GetShipperDetailByIDAction: async (shipperID: number) => {
        const response = await trackPromise(GetShipperDetailService(shipperID), 'shipper-detail-area');
        set({ shipperDetail: responseData(response?.data) || {} });
        return response;
    },
    GetConsigneeDetailByIDAction: async (shipperID: number) => {
        const response = await trackPromise(GetConsigneeDetailService(shipperID), 'shipper-detail-area');;
        set({ consigneeDetail: responseData(response?.data) || {} });
        return response;
    },
    GetAllBusinessGroupsAction: async () => {
        const response = await GetAllBusinessGroupsService();
        set({ businessGroupList: responseData(response?.data) });
    },
    DWSBookingRescheduleAction: async (request: IDWSChangeDeliveryDate, filterData: Partial<IFilter>) => {
        const response = await DWSBookingRescheduleService(request);
        const { statusCode } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle(response);
        }
    },
    GetReporteesAction: async (id: number) => {
        const response = await GetReporteesService(id);
        set({ reporteeList: responseData(response?.data) });
    },
    CreateSubWaybillsAction: async (request: ICreateSubWaybillsRequest, waybillNo: string) => {
        const response = await CreateSubWaybillsService(request);
        if (response?.status === TWO_HUNDRED_SUCCESS_CODE) {
            getNotificationStyle(response);
            trackPromise(get().GetSubWaybillsAction(waybillNo), "get-sub-waybills-area");
        }
    },
    GetSubWaybillsAction: async (waybillNo: string) => {
        const response = await GetSubWaybillsService(waybillNo);
        set({ subWaybillList: responseData(response?.data) || [] });
    },
    PrintSubWaybillAction: async (requestData: ISubWaybillPrint) => {
        const response = await PrintSubWaybillService(requestData);
        const { statusCode, data } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            trackPromise(downloadURL(data?.response), "print-sub-waybill-area");
        }
    },
    PrintSubWaybillStickerAction: async (requestData: ISubWaybillPrint) => {
        const response = await PrintSubWaybillStickerService(requestData);
        const { statusCode, data } = response?.data || {};
        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            trackPromise(downloadURL(data?.response), "print-sub-waybill-sticker-area");
        }
    },
    UpdateShipperByIdV2Action: async (request, id, onSuccess) => {
        const response = await UpdateShipperByIdV2Service(request, id);
        const { statusCode } = response?.data || {};

        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            const list = get().shipperCountryCity?.shipperDtoList ?? [];
            const filteredList = list.filter((item) => item?.id !== id);
            const shipper = list.find((item) => item.id === id) || {};
            const updatedShipper = { ...shipper, shortAddress: request?.shortAddress };
            set({
                shipperResponse: statusCode,
                shipperCountryCity: { shipperDtoList: [...filteredList, updatedShipper] as any },
            });
            onSuccess();
            getNotificationStyle(response?.data);
        }
    },
    UpdateConsigneeByIdV2Action: async (request, id, onSuccess) => {
        const response = await UpdateConsigneeByIdV2Service(request, id);
        const { statusCode } = response?.data || {};

        if (statusCode === TWO_HUNDRED_SUCCESS_CODE) {
            const list = get().consigneeCountryCity?.consigneeDtoList ?? [];
            const filteredList = list.filter((item) => item?.id !== id);
            const consignee = list.find((item) => item.id === id) || {};
            const updatedConsignee = { ...consignee, shortAddress: request?.shortAddress };
            set({
                consigneeCountryCity: { consigneeDtoList: [...filteredList, updatedConsignee] as any },
                consigneeResponse: statusCode,
            });
            getNotificationStyle(response?.data);
            onSuccess();
        }
    },
    ClearPodPendingList: () => set({ podDispatchPendingList: [] }),
    ClearStore: () => set(initialValue)
})))



export const useBookingStore = (BookingStore)